{
  "privacyPolicy": "Politique de confidentialité",
  "importantDisclosures": "Divulgations importantes",
  "termsOfUse": "Conditions d’utilisation",
  "yourFinancialGuide": "Votre guide d'éducation financière",
  "whatWeOffer": "Ce que nous offrons",
  "ourBusinessOppurtunity": "Notre opportunité d'affaires",
  "firstName": "Prénom",
  "lastName": "Nom de famille",
  "emailAddress": "adresse courriel",
  "emailMe": "Envoyez-moi un e-mail",
  "message": "Message",
  "messagePlaceholder": "Envoyez un message à votre représentant Primerica",
  "office": "Bureau",
  "mobile": "Mobile",
  "howCanIHelp": "Comment puis-je aider?",
  "send": "Envoyer",
  "scheduleAnAppointment": "Planifier un rendez-vous",
  "myServices": "Mes services",
  "investmentsAndSavings": "Investissements & épargne",
  "termLifeInsurance": "Assurance-vie temporaire",
  "mortgageLoans": "Prêts hypothécaires",
  "mortgageBranchOffice": "Succursale hypothécaire",
  "seeImportantDisclosures": "Veuillez consulter les divulgations importantes ci-dessous",
  "autoHomeOwners": "Programme de recommandation d’assurance habitation et automobile",
  "primericaBusinessOpportunity": "L’occasion d’affaires de Primerica",
  "aboutMe": "À propos de moi",
  "pfsInvestmentsRepUS": "Représentant enregistré de PFS Investments Inc.",
  "pfsInvestmentsRepCN": "Représentant de PFSL Investments Canada Ltd., courtier en fonds communs de placement",
  "lifeInsuranceRep": "Représentant en assurance-vie",
  "investmentAdviserRepUS": "Représentant-conseil en placement",
  "investmentAdviserRepCN": "Conseiller en sécurité financière Représentant Primerica, une entreprise d'assurance de personnes",
  "enterFirstName": "Entrez votre prénom correctement",
  "enterLastName": "Entrez votre nom de famille correctement",
  "enterEmail": "Entrez votre courriel correctement",
  "enterMessage": "Entrez votre message",
  "notAvailableInAll": "Non disponible dans tous les États/provinces",
  "lifeLicense": "Permis à vie",
  "importantDisclosuresLinkUS": "https://www.primerica.com/public/primerica_disclosures.html",
  "importantDisclosuresLinkCanada": "https://www.primericacanada.ca/public/canada/french/primerica_disclosures.html",
  "importantDisclosuresLink": "https://www.primericacanada.ca/public/canada/french/primerica_disclosures.html",
  "importantDisclosuresText": "Divulgations importantes",
  "termsOfUseLinkUS": "https://www.primerica.com/public/terms_conditions.html",
  "termsOfUseLinkCanada": "https://www.primericacanada.ca/public/canada/french/terms_conditions.html",
  "termsOfUseLink": "https://www.primericacanada.ca/public/canada/french/terms_conditions.html",
  "termsOfUseText": "Conditions d'utilisation",
  "privacyPolicyLinkUS": "https://www.primerica.com/public/privacy/online_privacy_policy_fr.html",
  "privacyPolicyLinkCanada": "https://www.primericacanada.ca/public/canada/french/canada_privacy.html",
  "privacyPolicyLink": "https://www.primericacanada.ca/public/canada/french/canada_privacy.html",
  "privacyPolicyText": "Politique de confidentialité"
}
